import React from "react";
import { Song } from "@/models/types";

interface JamTimelineProps {
  song: Song;
  currentTime: number;
  duration: number;
  onSeek: (t: number) => void;
}

const fmt = (s: number) => {
  if (!isFinite(s)) s = 0;
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
};

export const JamTimeline: React.FC<JamTimelineProps> = ({ song, currentTime, duration, onSeek }) => {
  const pct = duration ? (currentTime / duration) * 100 : 0;
  const sections = song.timeline.filter((e) => e.section);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    onSeek(ratio * duration);
  };

  return (
    <div className="w-full">
      <div
        data-testid="jam-timeline"
        onClick={handleClick}
        className="relative h-1.5 w-full rounded-full cursor-pointer"
        style={{ background: "rgba(255,255,255,0.08)" }}
      >
        <div
          className="absolute inset-y-0 left-0 rounded-full"
          style={{
            width: `${pct}%`,
            background: "linear-gradient(90deg,#D97706,#F59E0B)",
            boxShadow: "0 0 10px rgba(245,158,11,0.5)",
          }}
        />
        {sections.map((s, i) => (
          <div
            key={i}
            className="absolute top-1/2 -translate-y-1/2 rounded-full"
            style={{
              left: `${(s.time / duration) * 100}%`,
              width: 3,
              height: 3,
              background: "rgba(226,232,240,0.5)",
            }}
            title={s.section}
          />
        ))}
        <div
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full bg-amber-200"
          style={{ left: `${pct}%`, width: 10, height: 10, boxShadow: "0 0 10px rgba(245,158,11,0.8)" }}
        />
      </div>
      <div className="mt-1 flex justify-between font-mono text-[11px] text-slate-400">
        <span data-testid="jam-current-time">{fmt(currentTime)}</span>
        <span>{fmt(duration)}</span>
      </div>
    </div>
  );
};
